'use client';

import type { UnclaimedGamificationRewardsCount } from '../utils/getUnclaimedGamificationRewardsCount';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { useDailyBonusRewards } from '@/components/entities/dailyBonus/hooks/useDailyBonusRewards';
import { playerGamificationRewardsOptions } from '@/queries/playerGamificationRewards/playerGamificationRewards.queries';
import { useAppSelector } from '@/redux/hooks';
import { getUnclaimedGamificationRewardsCount } from '../utils/getUnclaimedGamificationRewardsCount';

const isDailyRewardAvailable = ({ state, onClick }: { state: string; onClick?: () => void }) => (
  state === 'ready' && typeof onClick === 'function'
);

export const useUnclaimedGamificationRewardsCount = (): UnclaimedGamificationRewardsCount => {
  const userSession = useAppSelector(state => state.user.userSession);
  const { cards: dailyRewards } = useDailyBonusRewards();
  const { data: groupedRewards } = useQuery(playerGamificationRewardsOptions.meGroupedRewards({
    enabled: !!userSession,
  }));

  return useMemo(() => {
    if (!userSession) {
      return getUnclaimedGamificationRewardsCount();
    }

    return getUnclaimedGamificationRewardsCount({
      groupedRewards,
      availableDailyRewardsCount: dailyRewards.filter(isDailyRewardAvailable).length,
    });
  }, [groupedRewards, dailyRewards, userSession]);
};
